'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ', ':checked:not(:disabled) ~ ', ' {\n    ', ' {\n      /* this is a stop-gap until we figure out a way of copying over assets */\n      /* do not change colors to use variables - Firefox requires HTML entity %23 rather than # */\n      background-image: url(\'data:image/svg+xml;utf8,<svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Checked checkbox</title><desc>A custom checked checkbox image</desc><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect fill="%23C3002F" x="0" y="0" width="50" height="50"></rect><text font-family="Helvetica, sans-serif" font-size="36" font-weight="normal" fill="%23FFFFFF"><tspan x="14.2324219" y="39">X</tspan></text></g></svg>\');\n      border: 0;\n      background-position: center;\n      background-size: contain;\n\n      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        background: ', ';\n\n        &::after {\n          content: \'X\';\n          color: ', ';\n          font-size: ', ';\n          font-weight: 600;\n          margin-left: 1px;\n          margin-top: 2px;\n        }\n      }\n    }\n  }\n\n  ', ':checked:disabled ~ ', ' {\n    ', ' {\n      /* this is a stop-gap until we figure out a way of copying over assets */\n      /* do not change colors to use variables - Firefox requires HTML entity %23 rather than # */\n      background-image: url(\'data:image/svg+xml;utf8,<svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Checked checkbox</title><desc>A custom checked checkbox image</desc><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect fill="%23FFFFFF" x="0" y="0" width="50" height="50"></rect><text font-family="Helvetica, sans-serif" font-size="36" font-weight="normal" fill="%23000000"><tspan x="14.2324219" y="39">X</tspan></text></g></svg>\');\n      border: 0;\n      background-position: center;\n      background-size: contain;\n\n      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        background: ', ';\n\n        &::after {\n          content: \'X\';\n          color: ', ';\n          font-size: ', ';\n          font-weight: 600;\n          margin-left: 1px;\n          margin-top: 2px;\n        }\n      }\n    }\n  }\n\n  &:hover {\n    ', ':not(:checked):not(:disabled) ~ ', ' {\n      ', ' {\n        background-color: ', ';\n        box-shadow: inset 0 0 0 2px ', ';\n      }\n    }\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: 100%;\n\n    label {\n      flex: 1;\n    }\n  }\n'], ['\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ', ':checked:not(:disabled) ~ ', ' {\n    ', ' {\n      /* this is a stop-gap until we figure out a way of copying over assets */\n      /* do not change colors to use variables - Firefox requires HTML entity %23 rather than # */\n      background-image: url(\'data:image/svg+xml;utf8,<svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Checked checkbox</title><desc>A custom checked checkbox image</desc><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect fill="%23C3002F" x="0" y="0" width="50" height="50"></rect><text font-family="Helvetica, sans-serif" font-size="36" font-weight="normal" fill="%23FFFFFF"><tspan x="14.2324219" y="39">X</tspan></text></g></svg>\');\n      border: 0;\n      background-position: center;\n      background-size: contain;\n\n      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        background: ', ';\n\n        &::after {\n          content: \'X\';\n          color: ', ';\n          font-size: ', ';\n          font-weight: 600;\n          margin-left: 1px;\n          margin-top: 2px;\n        }\n      }\n    }\n  }\n\n  ', ':checked:disabled ~ ', ' {\n    ', ' {\n      /* this is a stop-gap until we figure out a way of copying over assets */\n      /* do not change colors to use variables - Firefox requires HTML entity %23 rather than # */\n      background-image: url(\'data:image/svg+xml;utf8,<svg width="50px" height="50px" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Checked checkbox</title><desc>A custom checked checkbox image</desc><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><rect fill="%23FFFFFF" x="0" y="0" width="50" height="50"></rect><text font-family="Helvetica, sans-serif" font-size="36" font-weight="normal" fill="%23000000"><tspan x="14.2324219" y="39">X</tspan></text></g></svg>\');\n      border: 0;\n      background-position: center;\n      background-size: contain;\n\n      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        background: ', ';\n\n        &::after {\n          content: \'X\';\n          color: ', ';\n          font-size: ', ';\n          font-weight: 600;\n          margin-left: 1px;\n          margin-top: 2px;\n        }\n      }\n    }\n  }\n\n  &:hover {\n    ', ':not(:checked):not(:disabled) ~ ', ' {\n      ', ' {\n        background-color: ', ';\n        box-shadow: inset 0 0 0 2px ', ';\n      }\n    }\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    width: 100%;\n\n    label {\n      flex: 1;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rem = require('polished/lib/helpers/rem');

var _rem2 = _interopRequireDefault(_rem);

var _config = require('../../config.js');

var _Button = require('./components/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Input = require('./components/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Label = require('./components/Label');

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, /* sc-selector */_Input2.default, /* sc-selector */_Label2.default, /* sc-selector */_Button2.default, _config.colors.red, _config.colors.white, (0, _rem2.default)('14px', _config.typography.baseFontSize), /* sc-selector */_Input2.default, /* sc-selector */_Label2.default, /* sc-selector */_Button2.default, _config.colors.white, _config.colors.black, (0, _rem2.default)('14px', _config.typography.baseFontSize), /* sc-selector */_Input2.default, /* sc-selector */_Label2.default, /* sc-selector */_Button2.default, _config.colors.gray, _config.colors.white);

/**
# Radio Button
A basic radio button
 */
var Checkbox = function Checkbox(_ref) {
  var label = _ref.label,
      value = _ref.value,
      name = _ref.name,
      id = _ref.id,
      isChecked = _ref.isChecked,
      _onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      restProps = _objectWithoutProperties(_ref, ['label', 'value', 'name', 'id', 'isChecked', 'onChange', 'disabled']);

  return _react2.default.createElement(
    Wrapper,
    restProps,
    _react2.default.createElement(_Input2.default, {
      type: 'checkbox',
      id: id,
      value: value,
      checked: isChecked,
      disabled: disabled,
      onChange: function onChange(event) {
        return _onChange(event, name, value);
      }
    }),
    _react2.default.createElement(
      _Label2.default,
      {
        htmlFor: id,
        disabled: disabled,
        role: 'presentation'
      },
      _react2.default.createElement(_Button2.default, {
        disabled: disabled,
        $isChecked: isChecked
      }),
      label
    )
  );
};

Checkbox.propTypes = {
  /** The user-friendly label */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  /** A value to submit */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]).isRequired,
  /** An ID for the radio button */
  id: _propTypes2.default.string.isRequired,
  /** Whether the radio button is checked */
  isChecked: _propTypes2.default.bool.isRequired,
  /** Whether the radio button is disabled */
  disabled: _propTypes2.default.bool,
  /** A function to handle updates */
  onChange: _propTypes2.default.func.isRequired,
  /** A name to submit with the value */
  name: _propTypes2.default.string.isRequired
};

Checkbox.displayName = 'Checkbox';

exports.default = Checkbox;
Checkbox.__docgenInfo = {
  'description': '# Radio Button\r\nA basic radio button',
  'methods': [],
  'displayName': 'Checkbox',
  'props': {
    'disabled': {
      'defaultValue': {
        'value': 'false',
        'computed': false
      },
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': 'Whether the radio button is disabled'
    },
    'label': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }]
      },
      'required': false,
      'description': 'The user-friendly label'
    },
    'value': {
      'type': {
        'name': 'union',
        'value': [{
          'name': 'string'
        }, {
          'name': 'number'
        }, {
          'name': 'bool'
        }]
      },
      'required': true,
      'description': 'A value to submit'
    },
    'id': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'An ID for the radio button'
    },
    'isChecked': {
      'type': {
        'name': 'bool'
      },
      'required': true,
      'description': 'Whether the radio button is checked'
    },
    'onChange': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': 'A function to handle updates'
    },
    'name': {
      'type': {
        'name': 'string'
      },
      'required': true,
      'description': 'A name to submit with the value'
    }
  }
};